import React, { createContext, useContext, useState } from 'react'
import { BonusService } from 'lib/api/services/bonus.service'
import { useStateCallback } from 'hooks'

export const BonusStoreContext = createContext({
  bonusStore: {},
  bonusStoreFunc: {}
})

const INIT_FILTER = {
  phoneNumber: ''
}

const BonusStoreProviderManager = ({ ...props }) => {
  const [list, setList] = useState({
    transactions: [],
    totalPages: 0,
    totalElements: 0,
    totalAmount: 0,
    totalFrozen: 0
  })
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useStateCallback(INIT_FILTER)

  const getListBonuses = async () => {
    setLoading(true)
    try {
      const response = await BonusService.getBonuses({
        limit: 100,
        offset: 0,
        phoneNumber: filter.phoneNumber
      })

      if (response && response.status === 200) {
        setList(
          response.data || {
            transactions: [],
            totalPages: 0,
            totalElements: 0,
            totalAmount: 0,
            totalFrozen: 0
          }
        )
      } else {
        console.error('Error fetching bonuses:', response.error)
        setList({
          transactions: [],
          totalPages: 0,
          totalElements: 0,
          totalAmount: 0,
          totalFrozen: 0
        })
      }
    } catch (error) {
      console.error('Unexpected error:', error)
      setList({
        transactions: [],
        totalPages: 0,
        totalElements: 0,
        totalAmount: 0,
        totalFrozen: 0
      })
    }
    setLoading(false)
  }

  const onChangeFilter = event => {
    const { name, value } = event.target
    setFilter({ ...filter, [name]: value })
  }

  const bonusStore = {
    list,
    loading,
    filter
  }

  const bonusStoreFunc = {
    getListBonuses,
    onChangeFilter
  }

  return (
    <BonusStoreContext.Provider value={{ bonusStore, bonusStoreFunc }}>
      {props.children}
    </BonusStoreContext.Provider>
  )
}

export default BonusStoreProviderManager

export const useBonusStoreManager = () => useContext(BonusStoreContext)
